import React, { useEffect, useMemo } from "react";
import "./style.scss";
import BaseLayout from "../../../components/Layout";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { useAppDispatch } from "../../../hooks/useAppDispatch";
import {
  actionGetAlertasProperty,
  updateAlertasPropertyData,
} from "../../../features/alertas/getAll-alertas/slices";
import { actionGetPontosMonitoriaByLoja } from "../../../features/monitoramento/lista-pontos/slices";
import { actionGetPontosMonitoriaGeral } from "../../../features/getPontosMonitoramentoPorCliente/slices";
import { usePainelPublico } from "../../../hooks/usePainelPublico";
import connectSocket from "../../../helpers/connect-socket";
import { LoaderCircle } from "lucide-react";
import MapaGoogle from "../../../components/MapaGoogle";
import { actionGetAlertasAbertos } from "../../../features/alertas/slices";
import { actionGetDashboardGeral } from "../../../features/dashboard-geral/slices";

import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import { actionGetAlertasAbertosPublico } from "../../../features/(ApiKey)/alertas/get/slices";
import { actionGetDashboardGeralPublico } from "../../../features/(ApiKey)/Mapa/get/slices";

ChartJS.register(ArcElement, Tooltip, Legend);

// ==========================================
// 🎨 ÍCONES DOS CARDS
// ==========================================
const IconSetores = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);
const IconRiscos = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
    <line x1="12" y1="9" x2="12" y2="13" />
    <line x1="12" y1="17" x2="12.01" y2="17" />
  </svg>
);
const IconCaixaFerramentas = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
  </svg>
);
const IconPontosMonitoria = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const PagePropertyApiKeyDetalhada = () => {
  const dispatch = useAppDispatch();
  const {
    apiKey,
    status: statusApiKey,
    data: publicConfig,
  } = usePainelPublico();

  const lojaSelected = useAppSelector((state) => state.getLojas.lojaSelected);
  const idRegionalUser = 1;
  const idCliente = publicConfig?.idCliente as number;
  const currentIdLoja = lojaSelected ? Number(lojaSelected) : 0;

  // Selectors do Store
  const { data: metrics, status } = useAppSelector(
    (state) => state.getAlertasProperty,
  );
  const pontosMonitoriaByLoja = useAppSelector(
    (state) => state.pontosMonitoriaByLoja,
  );
  const pontosMonitoriaGeral = useAppSelector(
    (state) => state.getPontosMonitoriaGeral,
  );
  const alertas = useAppSelector((state) => state.getAlertasAbertosPublico);
  const getDashboardGeral = useAppSelector(
    (state) => state.getDashboardGeralPublico,
  ) as any;

  const loading = status === "loading";

  // ==========================================
  // 🧮 CÁLCULOS E TRATAMENTOS
  // ==========================================
  const totalPontosMonitoria = useMemo(() => {
    const dataSource =
      currentIdLoja > 0 ? pontosMonitoriaByLoja : pontosMonitoriaGeral;
    const grupos = dataSource?.data?.grupoMonitor;
    if (!grupos || !Array.isArray(grupos)) return 0;

    return grupos.reduce((acc: number, grupo: any) => {
      const qtdA = grupo.listaMonA?.length || 0;
      const qtdD = grupo.listaMonD?.length || 0;
      const qtdR = grupo.listaMonR?.length || 0;
      return acc + qtdA + qtdD + qtdR;
    }, 0);
  }, [pontosMonitoriaByLoja, pontosMonitoriaGeral, currentIdLoja]);

  const loadingPontos =
    currentIdLoja > 0
      ? pontosMonitoriaByLoja.status === "loading"
      : pontosMonitoriaGeral.status === "loading";

  const statusBrasilTratado = useMemo(() => {
    const mapaOriginal = getDashboardGeral?.data?.mapaBrasil;
    if (!mapaOriginal || !Array.isArray(mapaOriginal)) return {};

    return mapaOriginal.reduce((acc: any, item: any) => {
      if (item?.sigla) acc[item.sigla.toLowerCase()] = item.status;
      return acc;
    }, {});
  }, [getDashboardGeral?.data?.mapaBrasil]);

  const handleSocketUpdate = React.useCallback(
    (data: any) => {
      dispatch(updateAlertasPropertyData(data));
    },
    [dispatch],
  );

  // ==========================================
  // 🔌 EFEITOS E SYNC VIA API KEY
  // ==========================================
  useEffect(() => {
    let connection: any = null;

    if (idRegionalUser && idCliente && apiKey) {
      dispatch(
        actionGetAlertasProperty({ idLoja: 0, idCliente: idCliente, apiKey }),
      );
      dispatch(
        actionGetAlertasAbertosPublico({
          idLoja: 0,
          idCliente: idCliente,
          apiKey,
        }),
      );
      dispatch(actionGetDashboardGeralPublico(apiKey));

      if (currentIdLoja > 0) {
        dispatch(actionGetPontosMonitoriaByLoja(currentIdLoja, apiKey));
      } else {
        dispatch(actionGetPontosMonitoriaGeral(apiKey));
      }

      connection = connectSocket({
        url: "hubProperty",
        hub: "PropertyDados",
        cb: handleSocketUpdate,
        apiKey: apiKey,
        params: { idLoja: currentIdLoja },
      });
    }

    return () => {
      if (connection) connection.stop();
    };
  }, [
    currentIdLoja,
    handleSocketUpdate,
    idRegionalUser,
    idCliente,
    dispatch,
    apiKey,
  ]);

  // ==========================================
  // 📊 GRÁFICO DOUGHNUT DE IMPORTÂNCIA
  // ==========================================
  const valorBrutoImportancia = useMemo(() => {
    return Number(metrics?.importanciaSegurada) || 0;
  }, [metrics]);

  const valorFormatadoImportancia = useMemo(() => {
    return valorBrutoImportancia.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  }, [valorBrutoImportancia]);

  const dadosGraficoGauge = useMemo(() => {
    const maxEscala6Bi = 6000000000;
    const valorAtual = Math.min(valorBrutoImportancia, maxEscala6Bi);
    return {
      datasets: [
        {
          data: [valorAtual, maxEscala6Bi - valorAtual],
          backgroundColor: ["#ff9f43", "#cbd5e1"],
          borderWidth: 0,
        },
      ],
    };
  }, [valorBrutoImportancia]);

  const opcoesGraficoGauge = {
    responsive: true,
    maintainAspectRatio: true,
    aspectRatio: 2,
    rotation: -90,
    circumference: 180,
    cutout: "75%",
    plugins: { legend: { display: false }, tooltip: { enabled: false } },
  };

  // Filtro de Alertas Técnicos (Nível 9 Omitido no painel público de visualização)
  const listaAlertasDireita = useMemo(() => {
    const ID_LOJA_VALIDACAO = 2;
    const ID_REGIONAL_VALIDACAO = 11;

    if (!alertas?.data || !Array.isArray(alertas.data)) return [];

    return alertas.data.filter((item: any) => {
      const desc = (item.descricao || "").toLowerCase();
      const isOffline = desc.includes("offline");
      if (isOffline) return false;

      // Ignora Ambiente de Validação
      if (
        item.idLoja === ID_LOJA_VALIDACAO ||
        item.loja?.idRegional === ID_REGIONAL_VALIDACAO
      ) {
        return false;
      }

      // "Em aberto" = ainda não normalizado OU plano de ação ainda ativo
      const emAberto =
        item.dataNormalizacao === null || item.planoAcaoAtivo === true;

      return emAberto;
    });
  }, [alertas?.data]);

  // Bloqueio de Segurança
  if (statusApiKey === "unauthorized") {
    return (
      <div
        className="center-object-screen"
        style={{
          flexDirection: "column",
          textAlign: "center",
          padding: "20px",
        }}
      >
        <h2>Acesso não autorizado</h2>
        <p>
          Link inválido ou expirado. Solicite um novo link ao administrador.
        </p>
      </div>
    );
  }

  return (
    <div className="page-property-container">
      <aside className="property-aside">
        <div
          style={{
            borderBottom: "1px solid #334155",
            paddingBottom: "10px",
            display: "flex",
            justifyContent: "space-between",
            gap: "10px",
            alignItems: "center",
          }}
        >
          {publicConfig?.logos?.map((logoUrl: string, index: number) => (
            <img
              style={{ maxHeight: "35px", objectFit: "contain" }}
              key={index}
              src={logoUrl}
              alt={`Logo ${index + 1}`}
            />
          ))}
        </div>

        <div className="prop-metrics-vertical">
          <div className="prop-mini-card">
            <div className="card-header">
              <IconRiscos />{" "}
              <span className="card-header__label">Clientes</span>
            </div>
            <span className="prop-mini-card__value">
              {loading ? (
                <LoaderCircle className="loader" size={18} />
              ) : (
                metrics?.quantidadeClientes || 0
              )}
            </span>
          </div>

          <div className="prop-mini-card">
            <div className="card-header">
              <IconSetores /> <span className="card-header__label">Locais</span>
            </div>
            <span className="prop-mini-card__value">
              {loading ? (
                <LoaderCircle className="loader" size={18} />
              ) : (
                metrics?.quantidadeLojas || 0
              )}
            </span>
          </div>

          <div className="prop-mini-card">
            <div className="card-header">
              <IconSetores />{" "}
              <span className="card-header__label">Centrais</span>
            </div>
            <span className="prop-mini-card__value">
              {loading ? (
                <LoaderCircle className="loader" size={18} />
              ) : (
                metrics?.quantidadeCentrais || 0
              )}
            </span>
          </div>

          <div className="prop-mini-card">
            <div className="card-header">
              <IconPontosMonitoria />{" "}
              <span className="card-header__label">Pontos</span>
            </div>
            <span className="prop-mini-card__value">
              {loadingPontos ? (
                <LoaderCircle className="loader" size={18} />
              ) : (
                totalPontosMonitoria
              )}
            </span>
          </div>

          <div className="prop-mini-card">
            <div className="card-header">
              <IconCaixaFerramentas />{" "}
              <span className="card-header__label">Para Tratar</span>
            </div>
            <span className="prop-mini-card__value">
              {loading ? (
                <LoaderCircle className="loader" size={18} />
              ) : (
                metrics?.paraTratamento || 0
              )}
            </span>
          </div>

          <div className="prop-mini-card">
            <div className="card-header" style={{ color: "#c32e42" }}>
              <IconCaixaFerramentas />{" "}
              <span className="card-header__label">Ocorrências 30d</span>
            </div>
            <span className="prop-mini-card__value">
              {loading ? (
                <LoaderCircle className="loader" size={18} />
              ) : (
                metrics?.ocorrencias30d || 0
              )}
            </span>
          </div>

          <div className="prop-mini-card">
            <div className="card-header" style={{ color: "#10b981" }}>
              <IconCaixaFerramentas />{" "}
              <span className="card-header__label">Tratadas 30d</span>
            </div>
            <span className="prop-mini-card__value">
              {loading ? (
                <LoaderCircle className="loader" size={18} />
              ) : (
                metrics?.tratadas30d || 0
              )}
            </span>
          </div>

          <div className="prop-mini-card">
            <div className="card-header" style={{ color: "#10b981" }}>
              <IconCaixaFerramentas />{" "}
              <span className="card-header__label">Tratadas 90d</span>
            </div>
            <span className="prop-mini-card__value">
              {loading ? (
                <LoaderCircle className="loader" size={18} />
              ) : (
                metrics?.tratadas90d || 0
              )}
            </span>
          </div>
        </div>

        <div
          style={{
            marginTop: "auto",
            background: "white",
            padding: "1.2rem 1rem",
            borderRadius: 8,
            border: "1px solid #cbd5e1",
          }}
        >
          <h4
            style={{
              color: "#1e293b",
              fontSize: "0.9rem",
              marginBottom: "1rem",
              textAlign: "center",
              fontWeight: 700,
            }}
          >
            Importância Segurada
          </h4>

          <div
            className="prop-gauge-container"
            style={{
              position: "relative",
              width: "100%",
              maxWidth: "200px",
              margin: "0 auto",
            }}
          >
            <Doughnut data={dadosGraficoGauge} options={opcoesGraficoGauge} />

            <div
              style={{
                position: "absolute",
                bottom: "-5px",
                left: 0,
                width: "100%",
                textAlign: "center",
                fontWeight: 800,
                fontSize: "0.85rem",
                color: "#1e293b",
              }}
            >
              {valorFormatadoImportancia}
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "0.75rem",
              fontWeight: 700,
              color: "#64748b",
              marginTop: "1rem",
            }}
          >
            <span>R$ 0 Bi</span>
            <span>R$ 6 Bi</span>
          </div>
        </div>
      </aside>

      <main className="property-center-map">
        <MapaGoogle
          status={statusBrasilTratado}
          lojasMapa={getDashboardGeral?.data?.lojasMapa || []}
          zoom={4}
          tipoMapa="roadmap"
          tema="light"
          fillScreen={true}
        />
      </main>

      <aside className="property-aside">
        <div
          style={{
            color: "white",
            borderBottom: "1px solid #334155",
            paddingBottom: "10px",
          }}
        >
          <h2 style={{ fontSize: "1.2rem", margin: 0 }}>Últimos Alertas</h2>
        </div>

        {alertas?.status === "loading" ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "2rem",
            }}
          >
            <LoaderCircle
              className="loader"
              size={24}
              style={{ color: "white" }}
            />
          </div>
        ) : !listaAlertasDireita || listaAlertasDireita.length === 0 ? (
          <p
            style={{
              color: "#94a3b8",
              textAlign: "center",
              marginTop: "2rem",
              fontSize: "0.85rem",
            }}
          >
            Nenhum evento em andamento
          </p>
        ) : (
          <div
            className="prop-feed-scroll"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "0.5rem",
              width: "100%",
            }}
          >
            {listaAlertasDireita.map((alerta: any, idx: number) => (
              <div
                key={idx}
                style={{
                  background: "white",
                  padding: "0.75rem",
                  borderRadius: 8,
                  borderLeft: "4px solid #c32e42",
                }}
              >
                <strong
                  style={{
                    color: "#c32e42",
                    fontSize: "0.85rem",
                    display: "block",
                    marginBottom: "0.2rem",
                  }}
                >
                  {alerta.loja?.nome || `Loja ${alerta.idLoja}`}
                </strong>
                <p
                  style={{
                    margin: "0.4rem 0",
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    color: "#1e293b",
                    lineHeight: "1.3",
                  }}
                >
                  {alerta.descricao}
                </p>
                <small
                  style={{
                    color: "#64748b",
                    fontWeight: 700,
                    fontSize: "0.7rem",
                    display: "block",
                    textAlign: "right",
                    marginTop: "0.2rem",
                  }}
                >
                  {alerta.dataEvento
                    ? new Date(alerta.dataEvento).toLocaleString("pt-BR")
                    : ""}
                </small>
              </div>
            ))}
          </div>
        )}
      </aside>
    </div>
  );
};

export default PagePropertyApiKeyDetalhada;
